import { RouteRecordRaw } from 'vue-router';
import store from '../store';

const accountRoutes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'Login',
        meta: {
            title: 'Login',
            description: '',
        },
        component: () => import('@/views/account/loginPage.vue'),
    },
    {
        path: '/signup',
        name: 'Sign up',
        meta: {
            title: 'Sign up',
            description: '',
        },
        component: () => import('@/views/account/signUpPage.vue'),
    },
    {
        path: '/account/deals',
        redirect: '/deals',
    },
    {
        path: '/account/offers',
        redirect: '/deals',
    },
    {
        path: '/offers',
        redirect: '/deals',
    },
    {
        path: '/account/rewards',
        redirect: '/rewards',
    },
    {
        path: '/deals',
        name: 'Deals',
        meta: {
            title: 'Deals',
            description: '',
        },
        component: () => import('@/views/account/rewardPage.vue'),
    },
    {
        path: '/pizza-pals',
        name: 'Pizza Pals',
        component: () => import('@/views/bundle/pizzaPalsPage.vue'),
        beforeEnter: (to, from, next) => {
            const valueBundle = store.getters.getValueBundle;
            const validCoupons = store.getters.getValidCoupons;
            const couponNumber = valueBundle?.coupon_number;
            const hasValueBundleCoupon = !!validCoupons?.find((c) => parseInt(c.code) === parseInt(couponNumber));
            if (!hasValueBundleCoupon) {
                next(`/pizza-pals/${valueBundle.coupon_number}/1`);
            } else {
                next();
            }
        },
    },
    {
        path: '/deals/:couponNumber',
        name: 'Deal Builder',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber',
        component: () => import('@/views/bundle/bundlePage.vue'),
    },
    {
        path: '/deals/:couponNumber/:groupNumber',
        name: 'Deal Builder Group',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber/:groupNumber',
        component: () => import('@/views/bundle/groupPage.vue'),
    },
    {
        path: '/deals/:couponNumber/:groupNumber/:itemNumber',
        name: 'Deal Builder Item',
        meta: {
            title: 'Deal Builder',
            description: '',
            hideTabNavigation: true,
        },
        alias: '/pizza-pals/:couponNumber/:groupNumber/:itemNumber',
        component: () => import('@/views/bundle/itemPage.vue'),
    },
    {
        path: '/rewards',
        meta: {
            title: 'My Rewards',
        },
        component: () => import('@/views/account/rewardPage.vue'),
    },
    {
        path: '/rewards/menu',
        meta: {
            title: 'Rewards Menu',
        },
        component: () => import('@/views/account/rewardMenuPage.vue'),
    },
    {
        path: '/rewards/bonus-points',
        meta: {
            title: 'Bonus Points',
        },
        component: () => import('@/views/account/bonusPointsPage.vue'),
    },
    {
        path: '/rewards/signup',
        meta: {
            title: 'Rewards Signup',
        },
        component: () => import('@/views/account/rewardsSignUpForm.vue'),
    },
    {
        path: '/history',
        name: 'history',
        meta: {
            title: 'Account History',
        },
        props: true,
        component: () => import('@/views/account/historyPage.vue'),
    },
    {
        path: '/account',
        name: 'My Account',
        meta: {
            title: 'My Account',
            description: '',
            hideTabNavigation: true,
            backBtn: true,
        },
        component: () => import('@/views/account/accountPage.vue'),
        beforeEnter: (to, from, next) => {
            const isAuthenticated = store.getters.isLoggedIn;
            if (!isAuthenticated) {
                next('/login?redirect=/account');
            } else {
                next();
            }
        },
    },
];

export default accountRoutes;
